import React from "react";
import "Common/hooks/StyleFeatures/global.scss"
import { ShopFilled, BookOutlined, UnorderedListOutlined, SafetyCertificateOutlined, UserOutlined, DollarOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import SelfLandingPage from "../Dashboards/SelfLearnerDashboard/SelfLandingPage";
import AvailableCourses from "../Components/Courses/AvailableCourses";
import EnrolledCourses from "../Components/Courses/EnrolledCourses";
import CredentialsPage from "../Components/Credentials/Credentails";
import SelfLearnerProfile from "../Components/Profile/SelfLearnerProfile";
import ProtectedPage from "Common/Components/ProtectedPage";
import PaymentLedgerPage from "../Components/PaymentLedger/PaymentLedger";
import PurchasedExpertServicesPage from "../Components/ExpertService/PurchasedExpertServices";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/selfLearner-dashboard",
    icon: <ShopFilled size="12px" />,
    component: (
      <ProtectedPage navigateTo="/selfLearner-profile">
        <SelfLandingPage />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Available Courses",
    key: "available-courses",
    route: "/selfLearner-dashboard/available-courses",
    icon: <BookOutlined size="12px" />,
    component: (
      <ProtectedPage navigateTo="/selfLearner-profile">
        <AvailableCourses />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
   {
    type: "collapse",
    name: "Enrolled Courses",
    key: "enrolled-courses",
    route:  "/selfLearner-dashboard/enrolled-courses",
    icon: <UnorderedListOutlined size="12px" />,
    component: (
      <ProtectedPage navigateTo="/selfLearner-profile">
        <EnrolledCourses />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Credentials",
    key: "credentials",
    route: "/selfLearner-dashboard/credentials",
    icon: <SafetyCertificateOutlined size="12px" />,
    component: (
      <ProtectedPage navigateTo="/selfLearner-profile">
        <CredentialsPage />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
   {
    type: "collapse",
    name: "Expert Services",
    key: "expert-services",
    route: "/selfLearner-dashboard/purchased-expert-services",
    icon: <CustomerServiceOutlined  size="12px" />,
    component: (
      <ProtectedPage navigateTo="/selfLearner-profile">
        <PurchasedExpertServicesPage />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  // Add Profile route without ProtectedPage (so it's always accessible)
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/selfLearner-profile",
    icon: <UserOutlined size="12px" />,
    component: <SelfLearnerProfile />,
    noCollapse: true,
    hidden: true, // Optional: hide from sidebar
  },
    {
    type: "collapse",
    name: "Payment Ledger",
    key: "payment-ledger",
    route:  "/selfLearner-dashboard/payment-ledger",
    icon: <DollarOutlined size="12px" />,
    component: (
      <ProtectedPage navigateTo="/selfLearner-profile">
        <PaymentLedgerPage />
      </ProtectedPage>
    ),
    noCollapse: true,


  }
];

// Export the profile route separately
export const profileRoute = {
  path: "/selfLearner-profile",
  element: <SelfLearnerProfile />
};

export default routes;